const suffixes = [
  ['JR', 'Junior'],
  ['SR', 'Senior'],
  ['I', 'First'],
  ['II', 'Second'],
  ['III', 'Third'],
  ['IV', 'Fourth'],
  ['V', 'Fifth'],
  ['VI', 'Sixth'],
  ['VII', 'Seventh'],
  ['VIII', 'Eighth'],
  ['IX', 'Ninth'],
].map(([value, label]) => ({
  value,
  label,
}))

export const suffixOrder: { [key: string]: number } = {}
suffixes.forEach(({ value }, index) => {
  suffixOrder[value] = index
})

export default suffixes
